import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import Endpoint from "../../shared/endpoints";
import duesConstants from "../constants/duesConstants";

const getClientDues = (payload: any) =>
  api.get(Endpoint.retrieveClientDues, {
    params: {
      client: payload.clientId,
      ...(payload.paymentId && { payment: payload.paymentId }),
      ...(payload.page && { page: payload.page }),
      ...(payload.searchText && { search: payload.searchText }),
      ...(payload.from && { from: payload.from }),
      ...(payload.to && { to: payload.to }),
    },
  });

const getInvoiceDues = (payload: any) =>
  api.get(`${Endpoint.retrieveInvoiceDues}/${payload.id}/invoice-due-mapper/`);

function* getClientDuesAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(getClientDues, action.payload);
    yield put({
      type: duesConstants.GET_CLIENT_DUES_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: duesConstants.GET_CLIENT_DUES_FAILURE, err: e });
  }
}

function* getInvoiceDuesAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(getInvoiceDues, action.payload);
    yield put({
      type: duesConstants.GET_INVOICE_DUES_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: duesConstants.GET_INVOICE_DUES_FAILURE, err: e });
  }
}

function* duesSaga() {
  yield all([
    takeEvery(duesConstants.GET_CLIENT_DUES_REQUEST, getClientDuesAsync),
    takeEvery(duesConstants.GET_INVOICE_DUES_REQUEST, getInvoiceDuesAsync),
  ]);
}

export default duesSaga;
